import { CURRENT_CLIENT } from '@/constants'
import type { ClientWithLanding } from '@/landing/resolve-landing'

/** Opt-out: guest surfaces (landing, login, register) show theme toggle unless explicitly false. */
export function isLandingThemeToggleEnabled(): boolean {
  const client = CURRENT_CLIENT as ClientWithLanding
  return client.landing?.themeToggleEnabled !== false
}
